function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import vent from 'elements/vent';
import { fetchOrAbort } from 'elements/utils';
import flatpickr from 'flatpickr/dist/flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import tippy from 'tippy.js';
import 'tom-select/dist/css/tom-select.css';
import TomSelect from 'tom-select';
export var utils = new (/*#__PURE__*/function () {
  function Utils() {
    var _this = this;
    _classCallCheck(this, Utils);
    _defineProperty(this, "onScroll", function (e) {
      if (!window.lastScrollTop) {
        window.lastScrollTop = 0;
      }
      var st = window.pageYOffset;
      if (Math.abs(window.lastScrollTop - st) <= 120) return;
      if (st < window.lastScrollTop) {
        document.body.classList.remove('scroll-down');
      } else {
        if (st > 100) {
          document.body.classList.add('scroll-down');
        } else {
          document.body.classList.remove('scroll-down');
        }
      }
      window.lastScrollTop = st;
    });
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.observer = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _node$matches, _node$matches2, _node$matches3, _node$matches4, _node$matches5;
              var node = _step2.value;
              if (!(node instanceof HTMLElement)) continue;
              if ((_node$matches = node.matches) !== null && _node$matches !== void 0 && _node$matches.call(node, '[data-editor]')) _this.setEditor(node);
              if ((_node$matches2 = node.matches) !== null && _node$matches2 !== void 0 && _node$matches2.call(node, 'input[type="date"]')) _this.setdate(node);
              if ((_node$matches3 = node.matches) !== null && _node$matches3 !== void 0 && _node$matches3.call(node, '[data-toggle="tooltip"]')) _this.setTooltip(node);
              if ((_node$matches4 = node.matches) !== null && _node$matches4 !== void 0 && _node$matches4.call(node, '[data-autosuggest]')) _this.setAutoSuggest(node);
              if ((_node$matches5 = node.matches) !== null && _node$matches5 !== void 0 && _node$matches5.call(node, '[data-see-more]')) _this.setSeemore(node);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    vent.on('APP:READY', function (_) {
      _this.initObserveInterception();
      _this.init();
    });
    vent.on('APP:UNLOAD', function (_) {
      // remove all tooltip
      document.querySelectorAll('[data-tippy-root]').forEach(function (t) {
        return t.remove();
      });
    });
    document.addEventDelegate('click', function (e) {
      e.preventDefault();
      var isActive = e.target.getAttribute('data-active') == 'true';
      var seeMore = e.target.parentNode.querySelector('[data-see-more]');
      // seeMore.classList.remove('has-see-more');
      e.target.setAttribute('data-active', isActive ? 'false' : 'true');
      if (isActive) {
        seeMore.style.display = '';
      } else {
        seeMore.style.display = 'block';
      }
    }, '[data-see-more-link]');
  }
  return _createClass(Utils, [{
    key: "initObserveInterception",
    value: function initObserveInterception() {
      var _this2 = this;
      if (this.observerIntersection) {
        this.observerIntersection.disconnect();
      }
      this.observerIntersection = new IntersectionObserver(function (entries) {
        var _iterator3 = _createForOfIteratorHelper(entries),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _node$target$matches, _node$target;
            var node = _step3.value;
            if (!node.isIntersecting) continue;
            if (!(node.target instanceof HTMLElement)) continue;
            if ((_node$target$matches = (_node$target = node.target).matches) !== null && _node$target$matches !== void 0 && _node$target$matches.call(_node$target, '[data-notifs-read]')) _this2.setNotifsRead(node.target);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
      document.body.querySelectorAll('[data-observe]').forEach(function (item) {
        _this2.observerIntersection.observe(item);
      });
    }
  }, {
    key: "init",
    value: function init() {
      if (!this.observer) {}
      document.querySelectorAll('[data-editor]').forEach(this.setEditor);
      document.querySelectorAll('input[type="date"]').forEach(this.setdate);
      document.querySelectorAll('[data-toggle="tooltip"]').forEach(this.setTooltip);
      document.querySelectorAll('[data-autosuggest]').forEach(this.setAutoSuggest);
      document.querySelectorAll('[data-see-more]').forEach(this.setSeemore);
    }
  }, {
    key: "setEditor",
    value: function setEditor(textarea) {
      if (window.ClassicEditor) {
        if (!textarea.getAttribute('data-wysiwyg')) {
          textarea.setAttribute('data-wysiwyg', true);
          ClassicEditor.create(textarea, {}).then(function (editor) {
            // console.log(editor);
          })["catch"](function (error) {
            // console.error(error);
          });
        }
      }
    }
  }, {
    key: "setdate",
    value: function setdate(input) {
      if (!input.getAttribute('data-datepicker')) {
        input.setAttribute('data-datepicker', true);
        flatpickr(input, {
          enableTime: true,
          locale: 'fr',
          minuteIncrement: 1,
          hourIncrement: 1,
          minDate: 'today',
          altFormat: 'd/m/Y H:i',
          dateFormat: 'Y-m-d H:i',
          altInput: true //
        });
      }
    }
  }, {
    key: "setTooltip",
    value: function setTooltip(button) {
      if (!button.getAttribute('data-tooltip-ok')) {
        button.setAttribute('data-tooltip-ok', true);
        var tooltip = document.querySelector('#' + button.getAttribute('aria-describedby'));
        var options = _defineProperty(_defineProperty({
          content: tooltip ? tooltip.innerHTML : button.getAttribute('title') || button.getAttribute('aria-label'),
          appendTo: function appendTo() {
            return document.body;
          },
          allowHTML: true,
          interactive: true,
          // delay: 200,
          animation: false,
          trigger: button.getAttribute('data-click') ? 'click' : 'mouseenter focus'
        }, "trigger", 'click'), "popperOptions", {
          modifiers: [{
            name: 'preventOverflow',
            options: {
              boundary: document
            }
          }]
        });
        if (button.getAttribute('data-dropdown')) {
          options.theme = 'dropdown';
          options.arrow = false;
          options.offset = 0;
          options.placement = 'bottom-end';
        }
        if (button.getAttribute('data-placement')) {
          options.placement = button.getAttribute('data-placement');
        }
        tippy(button, options);
      }
    }
  }, {
    key: "setAutoSuggest",
    value: function setAutoSuggest(element) {
      if (!element.tselect) {
        var settings = {
          persist: false,
          closeAfterSelect: !element.multiple,
          // maxItems: this.hasMaxValue ? this.maxValue : null,
          loadThrottle: 400,
          plugins: ['remove_button'],
          allowEmptyOption: element.multiple,
          valueField: 'value',
          labelField: 'label',
          searchField: ['value', 'label', 'option'],
          create: element.getAttribute('data-create') ? true : false,
          createFilter: element.getAttribute('data-create-regex'),
          render: {
            option: function option(data, escape) {
              return "<div>".concat(data.option ? data.option : escape(data['label']), "</div>");
            },
            option_create: function option_create(data, escape) {
              return '<div class="create">Ajouter <strong>' + escape(data.input) + '</strong>&hellip;</div>';
            },
            no_results: function no_results(data, escape) {
              return '<div class="no-results">Aucun résultat trouvé</div>';
            }
          }
        };
        var url = element.getAttribute('data-url');
        if (url) {
          settings.loadingClass = 'is-loading';
          // settings.preload = this.hasLoadMinLengthValue ? 'none' : 'focus';
          // settings.shouldLoad = (query) => {
          //     return query.length >= (this.hasLoadMinLengthValue ? this.loadMinLengthValue : 2)
          // };
          settings.load = function (query, callback) {
            fetchOrAbort('autosuggest_' + element.name, url + encodeURIComponent(query)).then(function (response) {
              return response.json();
            }).then(function (json) {
              callback(json);
            })["catch"](function () {
              callback();
            });
          };
        }
        element.tselect = new TomSelect(element, settings);
      }
    }
  }, {
    key: "setSeemore",
    value: function setSeemore(elt) {
      var h = elt.clientHeight;
      elt.style.display = 'block';
      var delta = h - elt.clientHeight;
      elt.style.display = '';
      if (delta < 0) {
        elt.classList.add('has-see-more');
      } else {
        elt.classList.remove('has-see-more');
      }
    }
  }, {
    key: "setNotifsRead",
    value: function setNotifsRead(elt) {
      if (elt.sent) {
        return;
      }
      elt.sent = true;
      var ids = elt.getAttribute('data-notifs-read') || '';
      document.querySelector('#read-notifs input').value = ids;
      document.querySelector('#read-notifs').requestSubmit();
    }
  }]);
}())();